import { CLIENT_PORTAL_PATH, isAdmin } from '../../config/clientAccess';
import './ClientDashboardLayout.css';

const ClientDashboardLayout = ({
  clientName,
  subtitle,
  user,
  onLogout,
  reportLabel,
  children
}) => (
  <main className="client-dashboard-page">
    <section className="client-dashboard-panel">
      <header className="client-dashboard-header">
        <div className="client-dashboard-title">
          <span>Portal de clientes DataDos</span>
          <h1>{clientName}</h1>
          <p>{subtitle}</p>
        </div>

        <div className="client-dashboard-session">
          <span className="client-dashboard-email">{user?.email}</span>
          <div className="client-dashboard-actions">
            {isAdmin(user) && (
              <a href={CLIENT_PORTAL_PATH}>Cambiar cliente</a>
            )}
            <button type="button" onClick={onLogout}>Cerrar sesión</button>
          </div>
        </div>
      </header>

      <section className="client-dashboard-report" aria-label={reportLabel}>
        {children}
      </section>
    </section>
  </main>
);

export default ClientDashboardLayout;
